/**
 * @generated SignedSource<<0b509a2e5c0da26cc1b238e3817ce0cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EnableOtpInput = {
  code: string;
};
export type Toggle2FAEnableOtpMutation$variables = {
  input: EnableOtpInput;
};
export type Toggle2FAEnableOtpMutation$data = {
  readonly enableOtp: {
    readonly user: {
      readonly name: string | null;
      readonly username: string | null;
      readonly otpEnabled: boolean | null;
      readonly anonymousHash: string | null;
      readonly uuid: string | null;
      readonly roles: ReadonlyArray<string> | null;
      readonly confirmed: boolean | null;
      readonly chatApproval: boolean | null;
      readonly tipDisabled: boolean | null;
      readonly insertedAt: string | null;
      readonly kycState: string;
      readonly refProps: any | null;
      readonly preferences: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
        readonly valueJson: string | null;
      }> | null;
      readonly userStats: ReadonlyArray<{
        readonly name: string;
        readonly value: number;
        readonly meta: any | null;
      }>;
    };
  } | null;
};
export type Toggle2FAEnableOtpMutation = {
  variables: Toggle2FAEnableOtpMutation$variables;
  response: Toggle2FAEnableOtpMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EnableOtpPayload",
    "kind": "LinkedField",
    "name": "enableOtp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "otpEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "anonymousHash",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "confirmed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chatApproval",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tipDisabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insertedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kycState",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refProps",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserPreference",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "valueJson",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserStat",
            "kind": "LinkedField",
            "name": "userStats",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meta",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Toggle2FAEnableOtpMutation",
    "selections": (v3/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Toggle2FAEnableOtpMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "754f8dc982d98d3f4e7b641addfd57a6",
    "id": null,
    "metadata": {},
    "name": "Toggle2FAEnableOtpMutation",
    "operationKind": "mutation",
    "text": "mutation Toggle2FAEnableOtpMutation(\n  $input: EnableOtpInput!\n) {\n  enableOtp(input: $input) {\n    user {\n      name\n      username\n      otpEnabled\n      anonymousHash\n      uuid\n      roles\n      confirmed\n      chatApproval\n      tipDisabled\n      insertedAt\n      kycState\n      refProps\n      preferences {\n        key\n        value\n        valueJson\n      }\n      userStats {\n        name\n        value\n        meta\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7dbe7cef98a042b42b9f26a1da8637f";

export default node;
